"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowser = exports.createSizer = exports.debounce = exports.emptyFn = exports.formatDate = exports.__ = void 0;
const tslib_1 = require("tslib");
const format_1 = tslib_1.__importDefault(require("date-fns/format"));
const sk_1 = tslib_1.__importDefault(require("date-fns/locale/sk"));
exports.__ = (toTranslate) => {
    return toTranslate;
};
exports.formatDate = (date, formatStr) => {
    return format_1.default(new Date(date), formatStr, {
        locale: sk_1.default,
    });
};
exports.emptyFn = () => { };
exports.debounce = (func, timeout) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func(...args);
        }, timeout);
    };
};
exports.createSizer = (sizes, defaultValue) => {
    return (size) => size in sizes ? sizes[size] : defaultValue;
};
exports.isBrowser = () => typeof window !== 'undefined' &&
    typeof window.location !== 'undefined' &&
    typeof window.document !== 'undefined';
